(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-modules-card"] && !Shopify.designMode) return;
  try {
    (() => {
    let tooltip = null;
    let activeTarget = null;

    function getOrCreateTooltip() {
      if (!tooltip) {
        tooltip = document.createElement('span');
        tooltip.className = 'variant-option__tooltip';
        tooltip.setAttribute('role', 'tooltip');
        document.body.appendChild(tooltip);
      }
      return tooltip;
    }

    function showTooltip(trigger) {
      const tip = getOrCreateTooltip();
      tip.innerHTML = `<p>${trigger.dataset.tooltip}</p>
                       <p>Ref: ${trigger.dataset.sku}</p>
                      `;

      const rect = trigger.getBoundingClientRect();
      tip.classList.add('is-visible');

      const tipRect = tip.getBoundingClientRect();
      const left = rect.left + rect.width / 2 - tipRect.width / 2;
      const top = rect.top - tipRect.height - 8;

      tip.style.left = Math.max(8, left) + 'px';
      tip.style.top = top + 'px';

      activeTarget = trigger;
    }

    function hideTooltip() {
      if (tooltip) tooltip.classList.remove('is-visible');
      activeTarget = null;
    }

    document.addEventListener('mouseover', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (trigger) showTooltip(trigger);
    });

    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('.variant-option__tooltip-trigger')) hideTooltip();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.variant-option__tooltip-trigger');
      if (!trigger) {
        hideTooltip();
        return;
      }
      if (activeTarget === trigger) {
        hideTooltip();
      } else {
        showTooltip(trigger);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-card"] && !Shopify.designMode) return;
  try {
    // Swatch selection for resource cards rendered outside the product-card block
  // system (e.g. predictive search). The theme's SwatchesVariantPickerComponent
  // only updates the card image/link when a <product-card> ancestor exists, so
  // this capture-phase listener applies the equivalent behavior using the data
  // attributes already present on the swatch inputs.
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.name || !input.name.includes('-swatch')) return;

      const card = input.closest('.resource-card');
      if (!card || card.querySelector('product-card')) return;

      const previewUrl = input.dataset.previewImageUrl;
      const image = card.querySelector('.resource-card__image:not(.resource-card__image--secondary)');
      if (previewUrl && image instanceof HTMLImageElement) {
        image.removeAttribute('srcset');
        image.src = previewUrl;
      }

      const secondary = card.querySelector('.resource-card__image--secondary');
      if (secondary instanceof HTMLImageElement) {
        const hoverUrl = input.dataset.previewHoverImageUrl;
        if (hoverUrl) {
          secondary.removeAttribute('srcset');
          secondary.src = hoverUrl;
          secondary.style.removeProperty('display');
        } else {
          secondary.style.display = 'none';
        }
      }

      const link = card.querySelector('.resource-card__link');
      const variantId = input.dataset.variantId;
      if (link instanceof HTMLAnchorElement && variantId) {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.href = url.toString();
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initDrawerTabs(nav) {
      nav.querySelectorAll('.menu-drawer__tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const target = btn.getAttribute('data-tab-target');
          nav.querySelectorAll('.menu-drawer__tab-btn').forEach(function (b) {
            b.classList.remove('menu-drawer__tab-btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          nav.querySelectorAll('.menu-drawer__tab-panel').forEach(function (p) {
            p.classList.remove('menu-drawer__tab-panel--active');
          });
          btn.classList.add('menu-drawer__tab-btn--active');
          btn.setAttribute('aria-selected', 'true');
          const panel = nav.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('menu-drawer__tab-panel--active');
        });
      });
    }

    document.querySelectorAll('.menu-drawer__tabs-nav').forEach(initDrawerTabs);

    document.addEventListener('drawer:open', function () {
      document.querySelectorAll('.menu-drawer__tabs-nav').forEach(function (nav) {
        if (!nav.dataset.tabsInit) {
          initDrawerTabs(nav);
          nav.dataset.tabsInit = 'true';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
